import React from "react";
import MUIButton from '@mui/material/Button'

const Button = ({
    ...props
}) => {

    return (
        <MUIButton {...props} disableElevation={true}/>
    )
}

export default Button

